import { Component, Project } from "projen";
import { TextFile } from "projen/lib/textfile";
import { VERSION } from "../versions";

/**
 * Emits a `.nvmrc` file at the project root containing the Node.js
 * version pinned in {@link VERSION.NODE_WORKFLOWS}.
 *
 * The file gives `nvm`, `fnm`, `volta`, and IDE plugins a single
 * source of truth for the Node version local development should use,
 * matching the version every CI workflow installs via
 * `actions/setup-node`. Without it, devs on hosts whose default Node
 * is older than the floor required by tooling (Astro 6, Starlight,
 * pnpm 11) silently break after a regen.
 *
 * Projen has no built-in `.nvmrc` knob — the closest input is
 * `workflowNodeVersion`, which only drives CI. This component closes
 * the local-dev gap.
 */
export class Nvmrc extends Component {
  constructor(project: Project) {
    super(project);

    new TextFile(project, ".nvmrc", {
      // `lines` is joined with `\n` — adding an empty trailing entry
      // produces a POSIX-friendly trailing newline (`24\n`).
      lines: [VERSION.NODE_WORKFLOWS, ""],
      readonly: true,
    });
  }
}
